import * as userApi from '@/api/user';
import store from '@/store';
import _ from 'lodash';
// import {isAuthenticatedWithToken} from '@/mixins/auth';

export default {
    namespaced: true,
    state: {
      user: null,
    },
    mutations: {
      setUser(state, payload) {
        state.user = payload;
      },
      clearUser(state) {
        state.user = null;
      },
      SET_EXECUTOR_GUID(state, payload){
        if(state.user){
          state.user.executor_guid = payload
        }
      },
    },
    actions: {
      SET_USER({ commit }, payload) {
        commit('setUser', payload);
        store.dispatch('userSubscription/setSubscription', payload.subscription);
      },

      CLEAR_USER({ commit }) {
        commit('clearUser');
      },
      async loadingPromise({dispatch}){
        return dispatch('LOAD_IF_NOT_LOADED');
      },
      async UPDATE_USER({dispatch}){
        try{
          let res = await userApi.me();
          await dispatch('SET_USER', res.data);
          
          return Promise.resolve();
        }catch(e){
          console.log(e);
          dispatch('auth/logoutUser');
        }
      },

      UPDATE_EXECUTOR_GUID({commit}, payload){
        commit('SET_EXECUTOR_GUID', payload);
      },

      async LOAD_IF_NOT_LOADED({getters, dispatch}){
        if( ! getters.IS_LOADED ){
          return await dispatch('LOAD_USER');
        }
        return Promise.resolve();
      },
      
      async LOAD_USER({ dispatch}) {
        // if(isAuthenticatedWithToken() && localStorage.getItem('user')){
        //   let user = JSON.parse(localStorage.getItem('user'));
        //   dispatch('SET_USER', user);
        //   store.dispatch('menu/autoLoadMenu');
        // }
        return dispatch('UPDATE_USER').then(() => store.dispatch('menu/autoLoadMenu'));
        // return Promise.resolve();
      },
      async ADD_CONTACT({ dispatch }, payload){
        try{
          let response = await userApi.contactAdd(payload.type, payload.contact);
          await dispatch('UPDATE_USER');
          store.dispatch('notifications/SHOW_SUCCESS', 'Новый контакт успешно добавлен');
          return response;
        }catch(err){
          console.log(err);
          store.dispatch('notifications/SHOW_ERROR', 'Произошла ошибка при добавлении нового контакта');
          return null;
        }
      },
      async ADD_CONTACT_PHONE({ dispatch }, contact){
        let response = await dispatch('ADD_CONTACT', {type: 'PHONE', contact});
        return response;
      },
    },
    getters: {
      USER(state){
        return state.user
      },
      IS_LOADED(state) {
          return state.user !== null;
      },
      LAST_WORK_SPACE_ID(state){
        return state.user.last_work_space_id;
      },
      EMAIL(state, getters) {
        return getters.IS_LOADED ? state.user.email : null;
    },
      HAS_CONTACT_PHONE(state) {
        return state.user.has_contact_phone;
      },
      CONTACT_PHONES(state) {
        return state.user.contact_phones;
      },
      HAS_CONTACT_PHONE_NUMBER: (state, getters) => (phone) => {
        return getters.CONTACT_PHONES.includes(phone);
      },
      ACTUAL_AVATAR(state, getters){
        return getters.AVATAR ? "/avatars/" + getters.AVATAR : "@/assets/img/user/avatars/account-avatar.png";
      },

      INITIALS(state, getters){
        return getters.IS_LOADED ? state.user.initials : '';
      },
      AVATAR(state, getters){
        return getters.IS_LOADED ? state.user.avatar : null;
      },
      LAST_WORKSPACE_ID(state, getters){
        return getters.IS_LOADED ? state.user.last_work_space_id : '';
      },

      USER_NAME(state, getters) {
        return getters.IS_LOADED ? state.user.name : '';
      },
      USER_FULL_NAME(state, getters) {
        return getters.IS_LOADED ? state.user.name : '';
      },
      IS_ADMIN(state, getters){
        return getters.HAS_ROLE('admin');
      },
      HAS_ROLE: (state, getters) => (role) => {
        return getters.IS_LOADED ? state.user.role_names.includes(role) : false;
      },
      HAS_ROLES: (state, getters) => (roles) => {
        return _.intersection(getters.ROLES, roles).length > 0;
      },
      ROLES: (state, getters) => getters.IS_LOADED ? state.user.role_names : [],

      USER_ID: (state, getters) => getters.IS_LOADED ? state.user.id : null,
      
      COUNT_ORGANIZATIONS: (state, getters) => getters.IS_LOADED ? state.user.organizations_count : null,
      
      EXECUTOR_GUID: () => store.getters['organizationExecutor/EXECUTOR_GUID'],
    },
}